import { filter, find, reject } from "ramda";

import type { ProjectBasisFragment } from "@/modules/projects/graphql/projects-queries.gql.ts";

import type { GroupsWithProjects } from "./types";

export const extractPrivateGroups = (
  groups: GroupsWithProjects | null,
): [GroupsWithProjects | null, GroupsWithProjects | null] => {
  if (!groups) return [null, null];

  const _find = find<ProjectBasisFragment | null>((project) => project?.isPrivateWorkspace === true);
  const _filter = filter<(ProjectBasisFragment | null)[]>((projects) => (projects ? !!_find(projects ?? []) : false));
  const _reject = reject<(ProjectBasisFragment | null)[]>((projects) => (projects ? !!_find(projects ?? []) : false));

  return [_filter(groups), _reject(groups)];
};
